export class ItemFee {
  lsFeeId: string;
  name: string;
  unitQuantity: number;
  unitPrice: number;
  subtotal: number;
  total: number;
  parentSaleLineId: string;

  constructor(saleLine: SaleLine) {
    this.lsFeeId = `${saleLine.itemFeeID}` || '';
    this.name = `${saleLine.ItemFee?.name}` || '';
    this.unitQuantity = Number(saleLine.unitQuantity) ?? 0;
    this.unitPrice = Number(saleLine.unitPrice) ?? 0;
    this.subtotal = Number(saleLine.calcSubtotal) ?? 0;
    this.total = Number(saleLine.calcTotal) ?? 0;
    this.parentSaleLineId = `${saleLine.parentSaleLineID}` || '';
  }
}
